import styled from 'styled-components'
import { margin, MarginProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { createGetParam } from 'Theme'

type ToastVariants = ToastVariantsProps

export type ToastVariantsProps = {
  success?: boolean
  warning?: boolean
  danger?: boolean
  info?: boolean
}

export type ToastParams = {
  color: ToastVariants
  borderColor: ToastVariants
}

const variants = {
  color: {
    default: themeGet('colors.primary500'),
    success: themeGet('colors.success400'),
    warning: themeGet('colors.warning500'),
    danger: themeGet('colors.danger500'),
    info: themeGet('colors.info500'),
  },
  borderColor: {
    default: themeGet('colors.divider.default'),
    success: themeGet('colors.success900'),
    warning: themeGet('colors.warning800'),
    danger: themeGet('colors.danger900'),
    info: themeGet('colors.info800'),
  },
}

const getParam = createGetParam<typeof variants, ToastVariantsProps>(variants)

export type ContainerProps = ToastVariantsProps & MarginProps
export const IconContainer = styled.div`
  display: flex;
  flex-direction: column;

  > svg {
    width: 32px;
    height: 32px;
  }

  svg * {
    stroke-width: 24;
  }
`

export const Footer = styled.div.withConfig({
  shouldForwardProp: prop => !DIV_SHOULD_FORWARD_PROP.includes(prop),
})<MarginProps>`
  display: flex;
  width: 100%;
  flex-direction: row;

  ${margin};
`

export const Container = styled.div.withConfig({
  shouldForwardProp: prop =>
    ![
      ...DIV_SHOULD_FORWARD_PROP,
      'success',
      'warning',
      'danger',
      'info',
      'closeToast',
      'toastProps',
    ].includes(prop),
})<ContainerProps>`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: ${themeGet('space.2')}px;
  background-color: ${themeGet('colors.background.panel')};
  border-radius: 10px;
  gap: ${themeGet('space.4')}px;

  ${margin};

  &__progress-bar {
    background: ${getParam('color')};
  }

  ${Footer} {
    color: ${getParam('color')};
    button {
      color: ${getParam('color')};
    }
  }

  ${IconContainer} {
    color: ${getParam('color')};
  }
`

export const StyledButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  box-shadow: unset;
  margin: 0;
  padding: 0;
  border: 0;
  cursor: pointer;
  background: ${themeGet('colors.transparent')};
  color: ${themeGet('colors.text.body')};
`
